
import { Button } from '@/components/ui/button';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface PollsErrorStateProps {
  countryName?: string;
  onRefresh: () => void;
}

const PollsErrorState = ({ countryName, onRefresh }: PollsErrorStateProps) => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200">
      <h2 className="text-2xl font-bold text-nation-blue mb-6">Polls for {countryName}</h2>
      <div className="text-center py-6">
        <AlertCircle size={36} className="mx-auto text-red-500 mb-2" />
        <p className="text-gray-700 mb-4">Failed to load polls. There may be a connection issue.</p>
        <Button onClick={onRefresh} variant="outline" className="flex items-center">
          <RefreshCw size={16} className="mr-2" />
          Try Again
        </Button>
      </div>
    </div>
  );
};

export default PollsErrorState;
